import { Link } from 'react-router-dom';

const posts = [
  {
    category: 'Şirket Kuruluş',
    title: 'Şahıs Şirketi mi, Limited Şirket mi? Doğru Seçim Rehberi',
    excerpt: 'İki yapı arasındaki temel farklar, vergi avantajları ve sorumluluk sınırları açısından kapsamlı bir karşılaştırma.',
    readTime: '6 dk okuma',
    href: '/limited-mi-sahis-mi',
    img: 'https://public.readdy.ai/ai/img_res/3cbeaed986215c09a62aedd7b1d6fca9.jpg',
  },
  {
    category: 'Vergi',
    title: 'Vergi Nasıl Hesaplanır? 2026 Gelir Vergisi Dilimleri',
    excerpt: 'Güncel vergi dilimleri, beyanname süreçleri ve yasal indirimlerle vergi yükünüzü nasıl optimize edebilirsiniz.',
    readTime: '8 dk okuma',
    href: '/sahis-sirketi-vergi-oranlari',
    img: 'https://readdy.ai/api/search-image?query=financial%20charts%20and%20graphs%20on%20paper%2C%20tax%20documents%2C%20calculator%2C%20professional%20accounting%20workspace%2C%20clean%20white%20background%2C%20soft%20lighting%2C%20business%20finance%20concept%2C%20high%20quality&width=600&height=340&seq=blog002&orientation=landscape',
  },
  {
    category: 'E-Fatura',
    title: 'E-Fatura Kimler İçin Zorunlu? 2026 Güncel Bilgiler',
    excerpt: 'E-fatura ve e-arşiv fatura yükümlülükleri, geçiş süreci ve dikkat edilmesi gereken önemli noktalar.',
    readTime: '5 dk okuma',
    href: '/e-fatura-kimler-icin-zorunlu',
    img: 'https://readdy.ai/api/search-image?query=digital%20invoice%20on%20laptop%20screen%2C%20modern%20office%20environment%2C%20clean%20desk%2C%20professional%20business%20setting%2C%20soft%20blue%20and%20white%20tones%2C%20technology%20and%20finance%20concept%2C%20high%20quality%20photography&width=600&height=340&seq=blog003&orientation=landscape',
  },
];

const allTopics = [
  'KDV Nedir ve Nasıl Hesaplanır?',
  'KOSGEB Desteklerinden Nasıl Yararlanılır?',
  'Serbest Meslek Makbuzu Nedir?',
  'Enflasyon Muhasebesi Uygulamaları',
  'Yıllık Beyanname Rehberi',
];

export default function Blog() {
  return (
    <section id="blog" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-14">
          <div>
            <span className="text-xs font-semibold tracking-widest text-[#60A5FA] uppercase">Bilgi Merkezi</span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#0A2540] mt-3">
              Güncel Bilgiler
            </h2>
          </div>
          <span className="text-gray-400 text-sm">Mevzuat ve uygulamalar hakkında bilgilendirici içerikler</span>
        </div>

        {/* Blog Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {posts.map((post) => (
            <Link
              key={post.title}
              to={post.href}
              className="bg-white border border-gray-100 rounded-2xl overflow-hidden hover:-translate-y-1 transition-all duration-300 group cursor-pointer block"
            >
              <div className="relative overflow-hidden h-44">
                <img
                  src={post.img}
                  alt={post.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-white text-[#0A2540] text-xs font-semibold rounded-full">
                    {post.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-[#0A2540] font-semibold text-sm leading-snug mb-2 line-clamp-2">
                  {post.title}
                </h3>
                <p className="text-gray-500 text-xs leading-relaxed mb-4 line-clamp-3">{post.excerpt}</p>
                <div className="flex items-center justify-between">
                  <span className="text-gray-400 text-xs">{post.readTime}</span>
                  <span className="text-[#60A5FA] text-xs font-medium">Devamını Oku →</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Popular Topics */}
        <div className="bg-[#F5F7FA] rounded-2xl p-6 md:p-8">
          <h3 className="text-[#0A2540] font-semibold text-sm mb-4">Popüler Konular</h3>
          <div className="flex flex-wrap gap-2">
            {allTopics.map((topic) => (
              <span
                key={topic}
                className="px-4 py-2 bg-white border border-gray-200 text-gray-600 text-xs rounded-full hover:border-[#0A2540] hover:text-[#0A2540] transition-colors cursor-pointer whitespace-nowrap"
              >
                {topic}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
